/**
 * Vista previa del SKU (misma lógica que Backend/src/utils/generarSkuProducto.js).
 * El valor final puede llevar sufijo -2, -3… si ya existe en la tienda.
 */
export function slugifySkuPreview(nombre) {
  const raw = String(nombre ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");

  return (raw || "SKU").slice(0, 80);
}

export function getProductSku(product) {
  if (!product) return "";
  return String(product.sku ?? product.no_parte ?? "").trim();
}
